import { queryClient } from '@/queryClient';
import type { Marcador } from './types/Marcador';
import { API_MARCADOR_GET_KEY } from './api/apiMarcadorGet';

export function invalidateMarcadorQuery() {
    void queryClient.invalidateQueries({ queryKey: [API_MARCADOR_GET_KEY] });
}

export function marcadoresToStringTitle(marcadores: Marcador[] | null | undefined): string {
    if (!marcadores || marcadores.length === 0) {
        return '';
    }

    return `Marcadores: ${marcadores.map((m) => m.mar_titulo).join(', ')}`;
}

export function marcadoresToStringIdpk(
    marcadores: Marcador[] | null | undefined,
): string | undefined {
    if (!marcadores || marcadores.length === 0) {
        return undefined;
    }

    return `[${marcadores.map((m) => m.mar_idpk).join(',')}]`;
}
